// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuex from "vuex";
// import VuexSaga from 'vuex-saga';
import App from "./App";
import router from "./router";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import { store } from "./store.js";
import "./scss/base.scss";
import { translate, translateError } from "./translation/native_translate.js";
import appConfig from "../config/app_config";
import MultiFiltersPlugin from './plugins/MultiFilters';
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueHotelDatepicker from '@northwalker/vue-hotel-datepicker';
// import VueAppleSignin from 'vue-apple-signin';
import { LoaderPlugin } from 'vue-google-login';
// import dayspan
import DaySpanVuetify from 'dayspan-vuetify';
import 'dayspan-vuetify/dist/lib/dayspan-vuetify.min.css'
// import moment
import moment from 'moment';
moment().format();

Vue.config.devtools = true;

// Vue.use(VueAppleSignin, {
//   clientId: 'nl.thedrivingforce.signIn',
//   scope: 'email',
//   redirectURI: 'REDIRECT_URI',
//   state: 'STATE',
// });

Vue.use(DaySpanVuetify, {
  methods: {
    getDefaultEventColor: () => '#1976d2'
  }
});

Vue.use(LoaderPlugin, {
  client_id: '819961578899-kgl1peh7ij93tgrat26v8tgou8gtj95h.apps.googleusercontent.com'
});
Vue.use(VueHotelDatepicker);
Vue.use(VueFormWizard);
Vue.use(VueYouTubeEmbed);


Vue.use(Vuetify, {
  theme: {
    primary: '#006e95',
    secondary: "#70b1c8"
  }
});
Vue.use(Vuex);
// Vue.use(VuexSaga, { store: store });
Vue.use(MultiFiltersPlugin);

Vue.config.productionTip = false;
Object.defineProperty(Vue.prototype, "$translate", { value: translate });
Object.defineProperty(Vue.prototype, "$translateError", { value: translateError });

if (!appConfig.DEBUG) {
  console = console || {};
  console.log = function () { };
}

/* eslint-disable no-new */
class VueWrapper {
  constructor() {
    this.vue = new Vue({
      router,
      store,
      components: { App },
      template: "<App/>",
      beforeCreate() {
        window.setTimeout(() => {
          this.$store.dispatch("global/init");
        }, 1000);
      }
    });
  }
  fire(event, data = null) {
    this.vue.$emit(event, data);
  }

  listen(event, callback) {
    this.vue.$on(event, callback);
  }

  removeListener(event, callback) {
    this.vue.$off(event, callback);
  }

  getVue() {
    return this.vue;
  }

  showPage(page, params = null) {
    this.vue.$router.push({
      name: page,
      params: params
    });
  }
}
window.EventBus = new VueWrapper();

window.EventBus.getVue().$mount("#app");
